import React from 'react';

function Quotation() {
  return <div className="p-4 bg-gray-100 rounded-lg">Quotation content goes here.</div>;
}

export default Quotation;
